export const VERSION = { semver: '2026.11.4-283355.4b161687' };
